import { render, staticRenderFns } from "./BlankRouterSection.vue?vue&type=template&id=09b8ea7a&"
import script from "./BlankRouterSection.vue?vue&type=script&lang=js&"
export * from "./BlankRouterSection.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports